import { render, staticRenderFns } from "./CorestreamScreens.vue?vue&type=template&id=6571a3e1&scoped=true&"
import script from "./CorestreamScreens.vue?vue&type=script&lang=js&"
export * from "./CorestreamScreens.vue?vue&type=script&lang=js&"
import style0 from "./CorestreamScreens.vue?vue&type=style&index=0&id=6571a3e1&scoped=true&lang=css&"
import style1 from "./CorestreamScreens.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571a3e1",
  null
  
)

export default component.exports